import { usePostApiCrewTimesheets, } from '../../generated/sitComponents';
import { invalidateAllTimesheetsQueries } from './query';
export function usePostCrewTimesheet(options) {
    return usePostApiCrewTimesheets({
        ...options,
        onSuccess: async (data, variables, onMutateResult, context) => {
            await options?.onSuccess?.(data, variables, onMutateResult, context);
            await invalidateAllTimesheetsQueries(context.client);
        },
    });
}
//# sourceMappingURL=use-post-crew-timesheet.js.map